import { ReactElement } from 'react';
import { iInstalmentFormValues } from '@services/InstalmentService';

import { TextInput } from '@components';
import { Field, useFormikContext } from 'formik';

function InstalmentStep11(): ReactElement {
  const { values }: { values: iInstalmentFormValues } = useFormikContext();

  return (
    <div>
      {values.isDebtorTypeIndividual && (
        <div>
          <span className="vfH2">Income/expenses (optional)</span>
          <p>To help us assess your application, you can provide us with information about your income and expenses.</p>
          <Field component={TextInput} name="fortnightlyIncomeAfterTax" title="Your fortnightly income (after tax)" type="number" orientationRow />
          <Field component={TextInput} name="fortnightlyExpenses" title="Your fortnightly expenses" type="number" orientationRow />
        </div>
      )}
      {values.isDebtorTypeCompany && (
        <div>
          <span className="vfH2">Profit/loss (optional)</span>
          <p>To help us assess your application, you can provide us with information about the company's profit or loss.</p>
          <p>Please provide the company's quarterly profit or loss</p>
          <Field component={TextInput} name="quarterlyProfit" title="Profit" type="number" orientationRow />
          <Field component={TextInput} name="quarterlyLoss" title="Loss" type="number" orientationRow />
        </div>
      )}
    </div>
  );
}

export default InstalmentStep11;
